export const projects = [
  {
    siteName: "Stock hunt 🔍",
    url: "https://stock-hunt.netlify.app/",
    screenshots: "",
    discription:
      "Stock Hunt is a responsive website that allows you to easily search for 😅 all stocks 💰 listed on the NASDAQ by simply entering their 👏 ticker symbol. Additionally, you 👈 have 🈶 the ability to save and delete 🔋 items to a watchlist for 🌼 your convenience. 🏪",
    technologies: [
      "HTML",
      "CSS",
      "react js",
      "apex charts",
      "framer motion",
      "yahoo finance API",
      "react router",
    ],
    gitHubRipo: "https://github.com/LOLKTKAT/stock-finder",
    next: "movie app",
    type: "(personal)",
  },
  {
    siteName: "Movie app 🍿",
    url: "https://reactjsmovieappio.netlify.app/",
    screenshots: "",
    discription:
      "The Movie App is a responsive website that allows you 🫵 to browse 👣, search 🔍, and add movies 🍿 to a watchlist.",
    technologies: [
      "HTML",
      "CSS",
      "react js",
      "styled components	",
      "TMDB API",
      "react router",
    ],
    gitHubRipo: "https://github.com/LOLKTKAT/movie-app",
    next: "mySheets",
    type: "(personal)",
  },
  {
    siteName: "mySheets 🏫",
    url: "https://reactmysheets.netlify.app",
    screenshots: "",
    discription:
      "MySheets is a personal school 🚌 project that 🙇🚟 allows students to view and download 📲 their course 🐴 material in one simple and intuitive website.",
    technologies: [
      "HTML",
      "CSS",
      "react js ",
      "react router dom ",
      "firebase ",
      "styled components",
    ],
    gitHubRipo: "https://github.com/LOLKTKAT/my-sheets",
    next: "portfolio",
    type: "(personal)",
  },
  {
    siteName: "Portfolio 🏞️",
    url: "/",
    screenshots: "",
    discription: "Portfolio 🏞️ is my personal portfolio website ",
    technologies: [
      "HTML",
      "CSS",
      "react js ",
      "framer motion",
      "react router dom",
    ],
    gitHubRipo: "https://github.com/LOLKTKAT/maysara-website",
    next: "Stock Hunt",
    type: "(personal)",
  },
];
